import { render, staticRenderFns } from "./ProductInventory.vue?vue&type=template&id=2987ccae&scoped=true&"
import script from "./ProductInventory.vue?vue&type=script&lang=js&"
export * from "./ProductInventory.vue?vue&type=script&lang=js&"
import style0 from "./ProductInventory.vue?vue&type=style&index=0&id=2987ccae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2987ccae",
  null
  
)

export default component.exports